import { render, staticRenderFns } from "./AmendmentsTable.vue?vue&type=template&id=ca4cc2ac"
import script from "./AmendmentsTable.vue?vue&type=script&lang=js"
export * from "./AmendmentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports